<template>
  <div class="userInfo">
    <div class="top-nav-bar">
      <van-navBar title="个人资料" @click-left="$router.back()">
        <i class="icon back-arrow" slot="left"></i>
        <button class="btn" slot="right" @click="submit" v-if="userInfo.status!==4">保存</button>
        <button class="btn btn_01" slot="right" v-else>等待审核中...</button>
      </van-navBar>
    </div>
    <div class="mengceng" v-if="userInfo.status===4"></div>
    <div class="form">
      <div class="item">
        <div class="title">头像</div>
        <div class="imgWrap">
          <van-uploader max-count="1" :deletable="false" :before-read="beforeRead" :after-read="afterRead">
            <img class="avatar" :src="userInfo.avatar || require('@/assets/images/avatar_default_01.png')">
          </van-uploader>
          <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')">
        </div>
      </div>
      <div class="item">
        <div class="title">姓名</div>
        <div class="valueWrap">
          <van-field
            v-model="userInfo.name"
            placeholder="未完善"
            input-align="right"
          />
        </div>
      </div>
      <!-- <div class="item">
        <div class="title">手机号</div>
        <div class="valueWrap">
          <van-field
            v-model="userInfo.mobile"
            placeholder="未完善"
            input-align="right"
            readonly
          />
        </div>
      </div>
      <div class="item">
        <div class="title">邮箱</div>
        <div class="valueWrap">
          <van-field
            v-model="userInfo.email"
            placeholder="未完善"
            input-align="right"
          />
        </div>
      </div> -->
      <!-- <FjSelect v-model="userInfo.region" label="所属地区" placeholder="请选择所属地区" :columns="area" valueKey="code"  /> -->
      <div class="item">
        <div class="title">所属地区</div>
        <div class="valueWrap" @click="areaVisable = true">
          <span class="text" v-if="!address">请选择所属地区</span>
          <span class="text" v-else>{{ address }}</span>
          <img class="arrow arrow1" :src="require('@/assets/images/icon_arrow_03.png')">
        </div>
      </div>
      <van-popup position="bottom" v-model="areaVisable">
        <van-area title="请选择" :area-list="area" :value="userInfo.areaCode" @cancel="areaVisable = false" @confirm="selectArea"></van-area>
      </van-popup>
      <FjSelect  v-if="personInfo.role !== 'STUDENT'" v-model="userInfo.instituteId" label="所属机构" placeholder="请选择所属机构" :columns="instituteList" />
      <FjSelect v-model="userInfo.schoolId" label="所属学校" placeholder="请选择所属学校" :columns="schoolList" />
      <FjSelect v-if="personInfo.role !== 'STUDENT'" v-model="userInfo.teachSubject" title="科目" label="教授科目" placeholder="请选择教授科目" :columns="subjectList" valueKey="name" mode="multiple" />
      <div class="item" style="border:none;">
        <div class="title">个人简介</div>
      </div>
      <van-field
        v-model="userInfo.brief"
        rows="6"
        autosize
        type="textarea"
        class="richText"
        placeholder="说点什么...."
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { NavBar, Field, Uploader, Area } from 'vant';
import { FjSelect } from '@/components';
export default {
  name: 'UserInfo',
  components: { 'van-navBar': NavBar, 'van-field': Field, 'van-uploader': Uploader, 'van-area': Area, FjSelect },
  data () {
    return {
      userInfo: {},
      instituteList: [],
      schoolList: [],
      subjectList: [],
      areaVisable: false, // 地区选择弹层
      address: '',
      selectAreaCode: {
        provinceCode: '',
        cityCode: '',
        areaCode: ''
      }
    };
  },
  watch: {
    $route: {
      async handler ({ name }) {
        if (name === 'UserInfo') {
          await this.getUserInfo();
        }
      },
      immediate: true
    },
    // // // 通过地区获取机构
    // 'userInfo.areaCode': {
    //   handler (newValue) {
    //     if (newValue) {
    //       // security/apple/institute
    //       this.$http.get(`security/apple/institute?code=${newValue}`).then((res) => {
    //         // this.userInfo.instituteId = '';
    //         // this.userInfo.schoolId = '';
    //         this.instituteList = res.data || [];
    //       });
    //     }
    //   },
    //   immediate: true
    // },
    // 通过机构获取学校
    'userInfo.instituteId': {
      handler (newValue) {
        if (newValue) {
          this.$http.get(`security/apple/school?id=${newValue}`).then((res) => {
            this.schoolList = res.data || [];
          });
        }
      }
    }

  },
  computed: {
    ...mapGetters(['area', 'personInfo'])
  },

  mounted () {
    if (this.personInfo.role !== 'STUDENT') {
      this.getCourseList();
    }
  },

  methods: {

    getUserInfo () {
      this.$http.get('security/getUserInfo', { showLoading: true }).then((res) => {
        const { institute, school, user } = res.data;

        this.selectAreaCode = {
          provinceCode: this.userInfo.provinceCode,
          cityCode: this.userInfo.cityCode,
          areaCode: this.userInfo.areaCode
        };

        if (this.personInfo.role !== 'STUDENT') {
          this.userInfo = {
            ...user,
            instituteId: institute.id,
            schoolId: school.id,
            teachSubject: user.teachSubject ? user.teachSubject.split(',') : []
          };
          console.log(this.userInfo.instituteId);
          this.getCityInstitute(this.userInfo.cityCode);

        } else {
          this.userInfo = {
            ...user,
            schoolId: school.id
          };
          this.getSchool(this.userInfo.areaCode);
        }
        // this.getSchoolInstitute(this.userInfo.instituteId);
        this.getAddress();
      });
    },

    getCourseList () {
      this.$http.get('security/apple/info').then((res) => {
        const { subjects = [] } = res.data;
        this.subjectList = subjects;
      });
    },

    /* 上传头像前验证 */
    beforeRead (file) {
      console.log(file);
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$utils.failToast('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$utils.failToast('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    /* 上传头像 */
    afterRead (e) {
      const { $http, userInfo } = this;
      const formdata = new FormData();
      formdata.append('file', e.file);
      $http.post('upload/avatar', formdata, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        $http.put('security/modifyAvatar', {
          avatar: res.data.saveName
        }, {
          showLoading: true,
          loadingText: '上传中'
        }).then((_v) => {
          userInfo.avatar = res.data.path;
        });
      });
    },


    submit () {
      const { userInfo, selectAreaCode, $utils: { verifyEmpty, verifyArrEmpty }, $http } = this;
      if (this.personInfo.role !== 'STUDENT') {
        if (verifyEmpty(userInfo.name, '请完善姓名') &&
        verifyArrEmpty([selectAreaCode], '请选择所属地区') &&
        verifyEmpty(userInfo.instituteId, '请选择所属机构') &&
        verifyEmpty(userInfo.schoolId, '请选择所属学校') &&
        verifyArrEmpty(userInfo.teachSubject, '请选择教授科目')
        ) {
          $http.put('security/modifyInfo', {
            name: userInfo.name,
            id: userInfo.id,
            brief: userInfo.brief,
            mobile: userInfo.mobile,
            instituteId: userInfo.instituteId,
            schoolId: userInfo.schoolId,
            ...selectAreaCode,
            teachSubject: userInfo.teachSubject.join(',')
          }, {
            showLoading: true,
            loadingText: '保存中...'
          }).then(async (res) => {
            userInfo.status = 4;
            this.$utils.successToast(userInfo.status === 4 ? '保存完成,审核中,请耐心等待!' : '修改成功!');
          });
        }
      } else {
        if (verifyEmpty(userInfo.name, '请完善姓名') &&
        verifyArrEmpty([selectAreaCode], '请选择所属地区') &&
        verifyEmpty(userInfo.schoolId, '请选择所属学校')
        ) {
          $http.put('security/modifyInfo', {
            name: userInfo.name,
            id: userInfo.id,
            brief: userInfo.brief,
            schoolId: userInfo.schoolId,
            ...selectAreaCode
          }, {
            showLoading: true,
            loadingText: '保存中...'
          }).then(async (res) => {
            this.$utils.successToast('修改成功!');
          });
        }
      }
    },

    /* 选择地区 */
    selectArea (e) {
      let obj = {
        province: e[0].name,
        city: e[1].name,
        area: e[2].name
      };
      let arr = [];
      for (let key in obj) {
        arr.push(obj[key]);
      }
      this.selectAreaCode = {
        provinceCode: e[0].code,
        cityCode: e[1].code,
        areaCode: e[2].code
      };

      this.address = arr.join('/');

      if (this.personInfo.role !== 'STUDENT') {
        this.getCityInstitute(e[1].code);
      } else {
        this.getSchool(e[2].code);
      }
      this.areaVisable = false;
    },

    /* 获取当前的省市区 */
    getAddress () {
      let obj = {
        province: '',
        city: '',
        area: ''
      };
      let arr = [];
      for (let key in obj) {
        arr.push(this.userInfo[key]);
      }
      console.log();
      this.address = arr.includes('') ? '' : arr.join('/');
      if (arr.includes(null)) {
        this.address = '请选择地区';
      }
      this.areaVisable = false;
    },

    // 通过地区获取机构
    getCityInstitute (newValue) {
      this.$http.get(`security/apple/institute?code=${newValue}`).then((res) => {
        this.instituteList = res.data || [];
      });
    },

    // 通过地区获取学校
    getSchool (newValue) {
      this.$http.get(`h5/getSchoolByAreaCode?code=${newValue}`).then((res) => {
        this.schoolList = res.data || [];
        this.schoolList.push({ name: '其他', id: -1 });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.userInfo {
  .top-nav-bar {
    flex-shrink: 0;
    width: 100%;
    height: 94px;

    /deep/.van-nav-bar {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      height: 94px;
      margin: auto;
      background-color: #fff;

      &::after {
        border: none;
      }

      .van-nav-bar__title {
        font-size: 34px;
        font-weight: bold;
        line-height: 94px;
        color: #222;
        color: #1a1a1a;
      }

      .van-nav-bar__left {
        left: 0;
      }

      .van-nav-bar__right {
        right: 0;
      }

      .van-nav-bar__left,
      .van-nav-bar__right {
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 94px;
        padding: 0 30px;
      }

      .back-arrow {
        width: 32px;
        height: 32px;
        background-image: url("~@/assets/images/icon_backArrow_01.png");
        background-size: contain;
      }
      .btn {
        padding: 0 20px;
        height: 56px;
        background: linear-gradient(93deg, #2E86FF 0%, #5FA9FF 100%);
        border-radius: 8px;
        font-size: 24px;
        font-weight: 500;
        line-height: 46px;
        color: #fff;
        &.btn_01{
          background: #eee;
          color: #333;
        }
      }
    }
  }
  .mengceng{
    position: fixed;
    top:254px;
    left:0;
    right: 0;
    color: #fff;
    bottom: 0;
    z-index: 999999;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .form {
    .item {
      position: relative;
      height: 112px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 28px;
      background: #fff;
      border-bottom: 1px solid #eee;
      &:nth-child(1) {
        height: 160px;
      }
      .title {
        font-size: 28px;
        font-weight: 500;
        line-height: 40px;
        color: #333444;
      }
      .imgWrap {
        display: flex;
        align-items: center;
        justify-content: center;
        /deep/ .van-uploader,.avatar {
          width: 88px;
          height: 88px;
          background: #fff;
          border-radius: 50%;
          overflow: hidden;
          .van-image {
            width: 88px;
            height: 88px;
          }
        }
        .arrow {
          margin-left: 12px;
          width: 32px;
          height: 32px;
        }
      }
      .valueWrap {
        display: flex;
        align-items: center;
        justify-content: center;
        .text{
          font-size: 28px;
          color: #333444;
        }
        .value {
          font-size: 28px;
          font-weight: 500;
          line-height: 40px;
          color: #999AAA;
          margin-right: 14px;
        }
        .arrow {
          width: 32px;
          height: 32px;
          &.arrow1{
            margin-left: 12px;
          }
        }
      }
    }
    .richText{
      width: 100%;
      border-radius: 8px;
      /deep/.van-field__control{
        background: #F9FAFC;
        padding: 20px 0 0 20px;
      }
    }
  }
}
</style>